"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dataAdapterCache_1 = require("../../data_adapters/dataAdapterCache");
const RpcMethodType_1 = __importDefault(require("../../pluggableElementTypes/RpcMethodType"));
const BaseAdapter_1 = require("../../data_adapters/BaseAdapter");
class CoreGetMetadata extends RpcMethodType_1.default {
    constructor() {
        super(...arguments);
        this.name = 'CoreGetMetadata';
    }
    async execute(args, rpcDriver) {
        const pm = this.pluginManager;
        const deserializedArgs = await this.deserializeArguments(args, rpcDriver);
        const { sessionId, adapterConfig } = deserializedArgs;
        const { dataAdapter } = await (0, dataAdapterCache_1.getAdapter)(pm, sessionId, adapterConfig);
        return (0, BaseAdapter_1.isFeatureAdapter)(dataAdapter)
            ? dataAdapter.getMetadata(deserializedArgs)
            : null;
    }
}
exports.default = CoreGetMetadata;
